import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Mirrors the roleDashboard map in App.js's Unauthorized page.
const ROLE_DASHBOARD = {
  admin: '/admin/dashboard',
  clinic_admin: '/clinic/dashboard',
  clinic: '/clinic/dashboard',
  clinic_manager: '/clinic/dashboard',
  clinic_staff: '/staff-dashboard',
  employer: '/employer/dashboard',
  doctor: '/doctor/dashboard',
  patient: '/patient/dashboard',
  location_staff: '/staff-dashboard',
  location_manager: '/staff-dashboard',
};

export const dashboardPathForRole = (role) => ROLE_DASHBOARD[role] || '/';

export const isImpersonating = () => !!localStorage.getItem('impersonatorToken');

export const getImpersonationMeta = () => {
  try {
    return JSON.parse(localStorage.getItem('impersonationMeta') || 'null');
  } catch {
    return null;
  }
};

// Swaps the active session to the target user's and hard-navigates to
// their dashboard. The admin's own token/user are stashed so Exit can
// restore them exactly.
export const startImpersonation = async (userId, reason = '') => {
  if (isImpersonating()) {
    throw new Error('Already impersonating a user — exit that session first.');
  }
  const adminToken = localStorage.getItem('token') || '';
  const adminUser = localStorage.getItem('user') || '';

  const resp = await axios.post(`${API}/admin/impersonate/${userId}`, { reason });
  const { token, user, impersonation } = resp.data;

  localStorage.setItem('impersonatorToken', adminToken);
  localStorage.setItem('impersonatorUser', adminUser);
  localStorage.setItem('impersonationMeta', JSON.stringify(impersonation || {}));
  localStorage.setItem('token', token);
  localStorage.setItem('user', JSON.stringify(user));

  window.location.href = dashboardPathForRole(user.role);
};

export const exitImpersonation = async () => {
  const meta = getImpersonationMeta();
  const adminToken = localStorage.getItem('impersonatorToken');
  const adminUser = localStorage.getItem('impersonatorUser');

  if (meta?.logId) {
    try {
      await axios.post(`${API}/admin/impersonate/${meta.logId}/end`);
    } catch (_) { /* best-effort audit close */ }
  }

  localStorage.removeItem('impersonatorToken');
  localStorage.removeItem('impersonatorUser');
  localStorage.removeItem('impersonationMeta');

  let adminRole = null;
  if (adminToken) localStorage.setItem('token', adminToken);
  if (adminUser) {
    localStorage.setItem('user', adminUser);
    try { adminRole = JSON.parse(adminUser)?.role; } catch { /* ignore */ }
  }

  window.location.href = dashboardPathForRole(adminRole);
};
